<template>
  <div class="external-banners" v-if="banners.length > 0">
    <a class="external-banner" v-for="banner in banners" :href="banner.link">
      <img class="bg" :src="banner.image" :alt="banner.country">
      <img class="brand" :src="require('../assets/logo-fischer.svg')" v-if="banner.brand === 'fischer'" width="150">
      <img class="brand" :src="require('../assets/logo-exim.svg')" v-else  width="150">
      <div class="banner-info">

        <h2 v-if="banner.country !== false">{{banner.country}}</h2>
        <h2 v-else>{{state_info.name}} s
          <span v-if="banner.brand == 'fischer'"> CK FISCHER</span>
          <span v-else>EXIM Tours</span>
        </h2>
        <p v-if="!banner.hasOwnProperty('alternative_text')">Až {{banner.hotel_count}} zájezdů od <strong>{{banner.price_from | formatCurrency('Kč')}}</strong></p>
        <p v-else>{{banner.alternative_text}}</p>
      </div>
      <div class="placeholder">
        <vue-button size="md" :href="banner.link" icon-right="icon-arrow-right" :outlined="true" color="transparent">Podívejte se na nabídku</vue-button>
      </div>
    </a>
  </div>
</template>

<script>
import VueButton from "@/components/Button";
import axios from "axios";
import Spinner from "@/components/Spinner";

import pairing from "../pairing";

export default {
  name: "ExternalBanners",
  components: { Spinner, VueButton },
  props: {
    country_id_fischer: {
      required: false,
      default: 23,
      type: Number
    },
    country_id_exim: {
      required: false,
      default: 23,
      type: Array
    },
    state_info:{
      required: true,
      default: function(){
        return {
          id: 188,
          name: "Řecko"
        }
      }
    }
  },
  data: function (){
    return {
      banners: [
        {
          brand: "exim",
          country: false,
          image: "/assets/exim_banner.jpg",
          price_from: 15258,
          hotel_count: 5,
          link: false,
          alternative_text: "Nejširší výběr zájezdů za nejlepší ceny"
        },
        {
          brand: "fischer",
          country: false,
          image: "/assets/fischer_banner.jpg",
          price_from: 18753,
          hotel_count: 5,
          link: false,
          alternative_text: 'Dovolená s maximální kvalitou služeb'
        }
      ],
      loading: false
    }
  },
  mounted: function() {
    let url_fshr = '/mock/countries.json';

    const links = pairing.reduce((acc, val) => {

      if(val.id === this.state_info.id){
        acc = {
          link_fischer: val.link_fischer,
          link_exim: val.link_exim
        };
      }
      return acc;
    }, false);

    if(links !== false){
      this.banners[0].link = links.link_exim;
      this.banners[1].link = links.link_fischer;
    }else{
      this.banners = [];
    }

    /*axios.get(url_fshr, {}).then((response) => {
      if(response.status === 200){

        let categories = response.data.categories.filter((val, key)=>{
          return val.id === 17;
        });
        categories = categories[0];

        let destinations = categories.destinations.filter((val, key)=>{
          val.id === this.country_id_fischer;
        });
        console.log(destinations);

      }
    }).finally(() => {
      this.loading = false;
    });*/


  }
};
</script>

<style scoped lang="less">

  @import "../less/variables.less";
  .external-banners{
    display: flex;
    min-height: 40 * @spacer;
    margin: 2*@spacer 0px;
    flex-wrap: wrap;

    @media @tablet-normal{
      min-height: 20 * @spacer;
    }

    .external-banner{
      position: relative;
      flex-basis: 100%;
      margin-right: 0px;
      flex-basis: 100%;
      margin-bottom: @spacer;
      border-radius: @border-radius;
      overflow: hidden;

      &:before{
        content: "";
        position: absolute;
        left: 0px;
        right: 0px;
        bottom: 0px;
        height: 0px;
        box-shadow: 0px -30px 80px 35px rgba(0,0,0,0.5);
        z-index: 1;

      }

      @media @tablet-normal{
        flex-basis: calc((100% / 2) - (@spacer / 2));
        margin-right: @spacer;
        margin-bottom: 0;
      }

      .brand{
        width: 120px;
        height: auto;
        position: absolute;
        top: 0px;
        left: 0px;
        padding: @spacer;
        background-color: @white;
        border-bottom-right-radius: 6px;
      }

      &:hover{
        .placeholder{
          opacity: 1;
        }
      }

      &:nth-child(2n){
        margin-right: 0px;
      }

      .banner-info{
        position: absolute;
        bottom: 2*@spacer;
        left: 2* @spacer;
        color: @secondary;
        z-index: 2;

        h2{
          font-size: @font-size-06;
          margin-bottom: @spacer * 0.4;
          margin-top: @spacer;
        }

        h3{
          margin: 0px;
          letter-spacing: 2px;
          text-transform: uppercase;

        }

        p{
          margin: 0px;
          font-size: @font-size-04;
        }

      }

      > img.bg{
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .placeholder{
        background-color: @secondary-transparent;

        position: absolute;
        top: 0px;
        left: 0px;
        right: 0px;
        bottom: 0px;
        opacity: 0;
        transition: all 300ms ease-in-out;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 3;
      }
    }
  }
</style>
